import {
  type ColumnType,
  type Selectable,
  type Insertable,
  type Updateable,
} from 'kysely'
import { z } from 'zod'

/** Identifier type for public.site_layout_ */
export type SiteLayoutId = string & { __brand: 'SiteLayoutId' }

/** Represents the table public.site_layout_ */
export default interface SiteLayoutTable {
  /** Database type: pg_catalog.text */
  id: ColumnType<SiteLayoutId, SiteLayoutId, SiteLayoutId>

  /** Database type: pg_catalog.text */
  description: ColumnType<string | null, string | null, string | null>

  /** Database type: pg_catalog.timestamptz */
  createdAt: ColumnType<Date, Date | string | undefined, Date | string>
}

export type SiteLayout = Selectable<SiteLayoutTable>

export type SiteLayoutInitializer = Insertable<SiteLayoutTable>

export type SiteLayoutMutator = Updateable<SiteLayoutTable>

export const siteLayoutId = z.string() as unknown as z.Schema<SiteLayoutId>

export const siteLayout = z.object({
  id: siteLayoutId,
  description: z.string().nullable().optional(),
  createdAt: z.coerce.date(),
}) as unknown as z.Schema<SiteLayout>

export const siteLayoutInitializer = z.object({
  id: siteLayoutId,
  description: z.string().optional().nullable(),
  createdAt: z.coerce.date().optional(),
}) as unknown as z.Schema<SiteLayoutInitializer>

export const siteLayoutMutator = z.object({
  id: siteLayoutId.optional(),
  description: z.string().optional().nullable(),
  createdAt: z.coerce.date().optional(),
}) as unknown as z.Schema<SiteLayoutMutator>
